export default __webpack_public_path__ + "static/03.logo_diagram-70b4660fb6b0bfdc17071b837227614d.svg";